import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { CardContext, ICardContext } from 'context/cardContext';
import config from 'theme/config';
import './CardPlayerTeamAndPosition.scss';

const CardPlayerTeamAndPosition = () => {
  const { t } = useTranslation();
  const { teamName, shirtNumber, position, teamCode } = useContext<ICardContext>(CardContext);

  const text = [];
  if (config.settings.showShirtNumbers && shirtNumber) {
    text.push(`#${shirtNumber}`);
  }
  if (position) {
    text.push(t('position-' + position));
  }

  return (
    <div className="card-player-team-and-position">
      <div className="card-player-team-and-position__team">{t('team-name-' + teamCode, teamName)}</div>
      <div className="card-player-team-and-position__position">{text.join(' | ')}</div>
    </div>
  );
};

export default CardPlayerTeamAndPosition;
